import React, { useState, useEffect } from "react";
import { Filter } from "react-feather";
import VisitorNavbar from "../../component/VisitorNavbar";
import Footer from "../../component/Footer";
import { useParams } from "react-router-dom";
import { baseurl } from "../../Baseurl";
import axios from "axios";
import ServiceMan from "./ServiceMan";

const indianStates = [
  { value: "ALL", label: "All India" },
  { value: "AP", label: "Andhra Pradesh" },
  { value: "AR", label: "Arunachal Pradesh" },
  { value: "AS", label: "Assam" },
  { value: "BR", label: "Bihar" },
  { value: "CT", label: "Chhattisgarh" },
  { value: "GA", label: "Goa" },
  { value: "GJ", label: "Gujarat" },
  { value: "HR", label: "Haryana" },
  { value: "HP", label: "Himachal Pradesh" },
  { value: "JH", label: "Jharkhand" },
  { value: "KA", label: "Karnataka" },
  { value: "KL", label: "Kerala" },
  { value: "MP", label: "Madhya Pradesh" },
  { value: "MH", label: "Maharashtra" },
  { value: "MN", label: "Manipur" },
  { value: "ML", label: "Meghalaya" },
  { value: "MZ", label: "Mizoram" },
  { value: "NL", label: "Nagaland" },
  { value: "OR", label: "Odisha" },
  { value: "PB", label: "Punjab" },
  { value: "RJ", label: "Rajasthan" },
  { value: "SK", label: "Sikkim" },
  { value: "TN", label: "Tamil Nadu" },
  { value: "TS", label: "Telangana" },
  { value: "TR", label: "Tripura" },
  { value: "UP", label: "Uttar Pradesh" },
  { value: "UK", label: "Uttarakhand" },
  { value: "WB", label: "West Bengal" },
  { value: "AN", label: "Andaman and Nicobar Islands" },
  { value: "CH", label: "Chandigarh" },
  { value: "DN", label: "Dadra and Nagar Haveli and Daman and Diu" },
  { value: "DL", label: "Delhi" },
  { value: "JK", label: "Jammu and Kashmir" },
  { value: "LA", label: "Ladakh" },
  { value: "LD", label: "Lakshadweep" },
  { value: "PY", label: "Puducherry" },
];



const ServiceRepair = () => {
  const [products, setProducts] = useState([]);
  const [menus, setMenus] = useState([]);
  const [checkedCategories, setCheckedCategories] = useState([]);
  const [expandedCategories, setExpandedCategories] = useState([]);

  const { slug } = useParams();

  useEffect(() => {
    fetchServiceMen();
    fetchMenus();
  }, [slug]);

  const fetchServiceMen = async () => {
    try {
      const response = await axios.get(`${baseurl}getAllServiceMan`);
      setProducts(response.data?.data || []);
    } catch (err) {
      console.error("Error fetching service men:", err);
    }
  };

  const fetchMenus = async () => {
    try {
      const response = await axios.get(`${baseurl}getAllServiceCategories`);
      setMenus(response.data.data || []);
    } catch (error) {
      console.error("Error fetching menus:", error);
    }
  };

  const getChildren = (parentId) => menus.filter((m) => m.parent_id === parentId);

  const getAncestors = (categoryId) => {
    const ancestors = [];
    let current = menus.find((m) => m.id === categoryId);
    while (current && current.parent_id) {
      ancestors.push(current.parent_id);
      current = menus.find((m) => m.id === current.parent_id);
    }
    return ancestors;
  };

  const getDescendants = (categoryId) => {
    const descendants = [];
    const stack = [categoryId];
    while (stack.length > 0) {
      const currentId = stack.pop();
      const children = getChildren(currentId);
      children.forEach((child) => {
        descendants.push(child.id);
        stack.push(child.id);
      });
    }
    return descendants;
  };

const [selectedStates, setSelectedStates] = useState([]);

  const handleCheckboxChange = (categoryId) => {
    let updatedChecked = [...checkedCategories];

    if (checkedCategories.includes(categoryId)) {
      // Uncheck and remove descendants
      const toRemove = [categoryId, ...getDescendants(categoryId)];
      updatedChecked = updatedChecked.filter((id) => !toRemove.includes(id));
      setExpandedCategories(expandedCategories.filter((id) => !toRemove.includes(id)));
    } else {
      // Check and add ancestors
      const ancestors = getAncestors(categoryId);
      updatedChecked = Array.from(new Set([...updatedChecked, categoryId, ...ancestors]));

      // Expand if has children
      const hasChildren = getChildren(categoryId).length > 0;
      if (hasChildren && !expandedCategories.includes(categoryId)) {
        setExpandedCategories([...expandedCategories, categoryId]);
      }
    }

    setCheckedCategories(updatedChecked);
  };

  const handleToggleExpand = (categoryId) => {
    setExpandedCategories((prev) =>
      prev.includes(categoryId)
        ? prev.filter((id) => id !== categoryId)
        : [...prev, categoryId]
    );
  };

  const getCategoryLevel = (categoryId) => {
    let level = 0;
    let current = menus.find((m) => m.id === categoryId);
    while (current && current.parent_id) {
      level++;
      current = menus.find((m) => m.id === current.parent_id);
    }
    return level;
  };

  const getDeepestLevelChecked = () => {
    let maxLevel = -1;
    checkedCategories.forEach((catId) => {
      const level = getCategoryLevel(catId);
      if (level > maxLevel) maxLevel = level;
    });
    return maxLevel;
  };

  const checkedAtDeepestLevel = () => {
    const deepestLevel = getDeepestLevelChecked();
    return checkedCategories.filter((catId) => getCategoryLevel(catId) === deepestLevel);
  };

  const levelHeadings = ["What We Do", "Category", "Subcategory", "Sub-Subcategory"];

const renderGroupedCategories = (parentId = null, level = 0) => {
  if (level > 3) return null;

  // Filter categories for current level
  let currentLevelCategories = menus.filter((menu) => menu.parent_id === parentId);

  // Sort alphabetically by service_title
  currentLevelCategories = currentLevelCategories.sort((a, b) =>
    a.service_title.localeCompare(b.service_title)
  );

  // If nothing to show at this level
  if (currentLevelCategories.length === 0) return null;

  // Get checked item(s) at this level
  const checkedAtLevel = currentLevelCategories.filter(cat => checkedCategories.includes(cat.id));

  // Show all siblings at this level
  return (
    <div className="mb-4">
      <div className="fw-bold mb-2">{levelHeadings[level]}</div>

      <div className="ms-3">
        {currentLevelCategories.map((cat) => (
          <div key={cat.id}>
            <div className="form-check text-start text-dark mb-1">
              <input
                type="checkbox"
                className="form-check-input"
                id={`cat-${cat.id}`}
                checked={checkedCategories.includes(cat.id)}
                onChange={() => handleCheckboxChange(cat.id)}
              />
              <label
                htmlFor={`cat-${cat.id}`}
                className="form-check-label text-capitalize"
              >
                {cat.service_title}
              </label>
            </div>
          </div>
        ))}
      </div>

      {/* If any is selected, show next level for its children */}
      {checkedAtLevel.map((checkedCat) =>
        renderGroupedCategories(checkedCat.id, level + 1)
      )}
    </div>
  );
};


console.log("Checked categories with levels:", checkedCategories.map(id => ({
  id,
  level: getCategoryLevel(id),
})));






  return (
    <>
      <VisitorNavbar />
      <div className="container-fluid py-3">
        <div className="row g-4">
          {/* Sidebar Filters */}
          <div className="col-md-2 hide-on-mobile">
            <h4 className="product-desc-title">
              Filters <Filter size={20} />
            </h4>
            <div className="filter-sidebar">{renderGroupedCategories()}

              {/* Show Indian states only when Sub-Subcategory (level 3) is selected */} 
  {getDeepestLevelChecked() >= 3 && (
  <div className="mb-4">
    <div className="fw-bold mb-2">State</div>
    <div className="ms-3">
      {indianStates.map((state) => (
        <div key={state.value} className="form-check text-start text-dark mb-1">
          <input
            type="checkbox"
            className="form-check-input"
            id={`state-${state.value}`}
            checked={selectedStates.includes(state.value)}
            onChange={(e) => {
              const isChecked = e.target.checked;
              setSelectedStates((prev) =>
                isChecked
                  ? [...prev, state.value]
                  : prev.filter((val) => val !== state.value)
              );
            }}
          />
          <label  
            htmlFor={`state-${state.value}`}
            className="form-check-label text-capitalize"
          >
            {state.label}
          </label>
        </div>
      ))}
    </div>
  </div>
)}


            </div>
          </div>

          {/* Service List */}
          <div className="col-md-10"> 

            <ServiceMan
  checkedCategories={checkedAtDeepestLevel()}
  selectedStates={selectedStates}
/>

          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ServiceRepair;
